"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DomainForm;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _domainSearch = _interopRequireDefault(require("@site/pattern-library-core/domain-search"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _core = require("@linaria/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const formStyles = "pl-f1gilfgq";
const errorTextStyles = "pl-e18l1w6";
function getValidTlds(products) {
  if (typeof products !== 'undefined') {
    let tldStr = '';
    let tldArr = [];
    products?.map(product => {
      tldStr += product.ProductInfoName + ' ' + product.ProductInfoFriendlyDescription + ' ';
    });
    tldArr = tldStr.match(/\.[\w.]+?(?=[^\w.])/gi);
    tldArr = [...new Set(tldArr)]; // remove Duplicates
    tldArr.sort(function (a, b) {
      return b.toLowerCase() === '.com';
    }); // if .com exists, move it to the front

    return tldArr;
  }
}
function validateTld(domainSearchedFor, validTlds) {
  let tldIsValid = true;
  if (domainSearchedFor.length > 0) {
    const tldMatch = `(${validTlds.join('|').replace(/\./gi, '\\.')})`;
    const domainMatch = '([a-zA-Z0-9-])';
    const tldsRegEx = new RegExp(`^${domainMatch}+${tldMatch}?$`, 'gi');
    tldIsValid = tldsRegEx.test(domainSearchedFor);
  }
  return tldIsValid;
}
function DomainForm({
  id,
  isLoading,
  domainSearchUrl,
  domainPlaceholder,
  redemptionApiResponse,
  ci,
  errorValidDomainsInclude,
  chooseDomain,
  domainFromQuery,
  btnSearch,
  handleOnSearch,
  ...domainSearch
}) {
  const [errorText, setErrorText] = (0, _react.useState)(false);
  const [domainSearchValue, setDomainSearchValue] = (0, _react.useState)(domainFromQuery);

  // object will be JSON wrapped in a string
  const rcConfigData = JSON.parse(redemptionApiResponse.Products[0].ConfigData || '{}');
  const tmskey = rcConfigData.TmsKey || 'dpp_redemption_flow';
  const validTlds = getValidTlds(redemptionApiResponse.Products);
  const defaultTld = validTlds[0];
  const additionalUrlParams = `?rc=${redemptionApiResponse.Code}` + (ci ? `&ci=${ci}` : '') + `&vendorid=${redemptionApiResponse.PartnerId}` + `&packageid=${redemptionApiResponse.PackageId}` + `&tld=${defaultTld}`;
  function handleOnChange(domainSearchedFor, callbackWhenValidfn) {
    domainSearchedFor = domainSearchedFor.trim();
    setDomainSearchValue(domainSearchedFor);
    if (validateTld(domainSearchedFor, validTlds)) {
      setErrorText('');
      if (typeof callbackWhenValidfn === 'function') {
        callbackWhenValidfn(domainSearchedFor);
      }
    } else {
      setErrorText(errorValidDomainsInclude.replace('{tldList}', validTlds));
    }
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    id: `search-div-${id}`,
    className: formStyles,
    "data-cy": "domain-form"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "text-center"
  }, chooseDomain), /*#__PURE__*/_react.default.createElement(_domainSearch.default, (0, _extends2.default)({
    id: `search-domain-${id}`,
    apiKey: "dpp_search",
    endpointType: {
      url: domainSearchUrl,
      searchFieldName: 'domainToCheck',
      _name: ''
    },
    disabled: isLoading,
    urlParams: additionalUrlParams,
    personalizationKey: tmskey,
    checkAvail: true,
    placeholder: domainPlaceholder,
    buttonText: btnSearch,
    ariaLabelInput: domainPlaceholder,
    ariaLabelButton: btnSearch,
    handleOnSearch: url => {
      handleOnChange(domainSearchValue, () => {
        handleOnSearch(url);
      });
    },
    onChange: handleOnChange,
    query: domainSearchValue
  }, domainSearch)), errorText && /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "input-error",
    className: `text-center ${errorTextStyles}`
  }, errorText));
}
DomainForm.propTypes = {
  id: _propTypes.default.string,
  ci: _propTypes.default.string,
  initialValue: _propTypes.default.string,
  domainSearchUrl: _propTypes.default.string,
  domainPlaceholder: _propTypes.default.string,
  redemptionApiResponse: _propTypes.default.shape({
    Products: _propTypes.default.array,
    Code: _propTypes.default.string,
    PartnerId: _propTypes.default.number,
    PackageId: _propTypes.default.number
  }),
  domainFromQuery: _propTypes.default.string,
  isLoading: _propTypes.default.bool,
  chooseDomain: _propTypes.default.string,
  errorValidDomainsInclude: _propTypes.default.string,
  errorDomainAlreadyInCart: _propTypes.default.string,
  domainPLace: _propTypes.default.string,
  btnSearch: _propTypes.default.string,
  handleOnSearch: _propTypes.default.func
};